import { cn } from "@/utils/cn";
import type { RosterNurse } from "@vTypes/snapshot-type";

/** 실측 앵커: 1칸 67px, 7칸 512px */
const ASSIGNMENT_BAR_MIN_SPAN = 1;
const ASSIGNMENT_BAR_MIN_WIDTH_PX = 67;
const ASSIGNMENT_BAR_MAX_SPAN = 7;
const ASSIGNMENT_BAR_MAX_WIDTH_PX = 512;

function assignmentBarWidthPx(spanDays: number): number {
  if (spanDays <= ASSIGNMENT_BAR_MIN_SPAN) return ASSIGNMENT_BAR_MIN_WIDTH_PX;
  if (spanDays >= ASSIGNMENT_BAR_MAX_SPAN) return ASSIGNMENT_BAR_MAX_WIDTH_PX;

  // 1칸~7칸 구간을 선형 보간해서 마진/경계 누적 오차를 완화.
  const perGap =
    (ASSIGNMENT_BAR_MAX_WIDTH_PX - ASSIGNMENT_BAR_MIN_WIDTH_PX) /
    (ASSIGNMENT_BAR_MAX_SPAN - ASSIGNMENT_BAR_MIN_SPAN);
  const raw =
    ASSIGNMENT_BAR_MIN_WIDTH_PX + (spanDays - ASSIGNMENT_BAR_MIN_SPAN) * perGap;
  return Math.round(raw);
}

function ViewRosterDay({
  day,
  holiday,
  myShift,
  /** 카탈로그 기준 표시용(예: `shift_id`). 없으면 `myShift` 원문 사용 */
  displayShiftId,
  color,
  coworkerList,
  assignmentBar,
}: {
  day: number;
  holiday: { weekend: number; isHol: boolean };
  myShift: string | null;
  displayShiftId?: string | null;
  color: string;
  coworkerList: RosterNurse[] | undefined;
  /** 파견 등 — `w_selectCalendar_date`(시프트 영역) 기준 `absolute` 하단 바 */
  assignmentBar?: { label: string; color: string; spanDays: number } | null;
}) {
  const normalizedShift = (myShift ?? "").trim();
  const hasShift = normalizedShift !== "" && normalizedShift !== "-";
  const hasColor = !!color && color !== "transparent";
  const label =
    (displayShiftId ?? "").trim() || (hasShift ? normalizedShift : "");

  return (
    <div
      className={`
                ${holiday.weekend === 6 ? "!text-text-sat" : holiday.weekend === 0 ? "!text-text-sun" : ""}
                ${holiday.isHol && "text-text-holiday"}
               w_selectCalendar_date coworkerListWrap !text-text-sub
         ${hasShift && hasColor && "!text-white"}
            w-full min-w-0
            `}
    >
      <div className="calendar-date !p-1">{day}</div>
      <div
        className={cn(
          "w_selectCalendar_shiftButton text-3xl!",
          !hasShift && "bg-muted! text-accent-foreground/10!"
        )}
        style={{ backgroundColor: color }}
      >
        {hasShift ? label : "-"}
        {coworkerList && coworkerList.length > 0 && (
          <div className="coworkerList">
            <ul>
              {coworkerList.map((n, index) => {
                return <li key={index}>{n.name}</li>;
              })}
            </ul>
          </div>
        )}
      </div>
      {assignmentBar != null &&
        assignmentBar.label !== "" &&
        assignmentBar.spanDays >= 1 && (
          <div
            className="pointer-events-none absolute bottom-0 rounded-b-sm left-0 z-[5] flex min-w-0 max-w-none items-center justify-center overflow-hidden py-0.5 text-center text-[11px] font-semibold leading-tight text-white"
            style={{
              width: `${assignmentBarWidthPx(assignmentBar.spanDays)}px`,
            }}
          >
            <div
              className="absolute inset-0 backdrop-blur-sm"
              style={{ backgroundColor: assignmentBar.color, opacity: 0.8 }}
            />
            <span className="relative z-[1] block min-w-0 max-w-[80%] truncate px-0.5 text-center">
              {assignmentBar.label}
            </span>
          </div>
        )}
    </div>
  );
}
export default ViewRosterDay;
